import styled from 'styled-components'

const HelperTextWrapper = styled.span`
  & > span {
    display: flex;
    padding-left: 10px;
    padding-top: 2px;
    margin-top: ${({ setMarginTop }) => (setMarginTop ? '20px' : '0px')};
  }

  & svg {
    font-size: 16px;
    margin-right: 4px;
  }
`

export { HelperTextWrapper }
